"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMAGE_PARAMS = exports.IMAGE_DESKTOP_WIDTH = exports.IMAGE_DESKTOP_HEIGHT = void 0;
var _utils = require("../../utils");
const IMAGE_DESKTOP_WIDTH = exports.IMAGE_DESKTOP_WIDTH = 985;
const IMAGE_DESKTOP_HEIGHT = exports.IMAGE_DESKTOP_HEIGHT = 590;
const IMAGE_PARAMS = exports.IMAGE_PARAMS = (0, _utils.getImageParamsAndSizes)({
  desktopWidth: IMAGE_DESKTOP_WIDTH
});
